/**
 * Classic methods that supported by backend
 */
export const RequestMethods = {
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT',
    Patch: 'PATCH',
    Delete: 'DELETE',
};
